import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../../shared';

import {
  ButtonDirective,
  IconButtonDirective,
  LargeButtonDirective,
  RaisedButtonDirective,
  SmallButtonDirective,
  StrokedButtonDirective,
} from './button.directive';
import { TextDirective } from './text.directive';

const DIRECTIVES = [
  ButtonDirective,
  RaisedButtonDirective,
  StrokedButtonDirective,
  IconButtonDirective,
  SmallButtonDirective,
  LargeButtonDirective,
  TextDirective,
];

@NgModule({
  declarations: [...DIRECTIVES],
  exports: [SharedDependenciesModule, ...DIRECTIVES],
  imports: [SharedDependenciesModule],
})
export class CommonUIModule {}
